import { useMemo } from "react"

import { useTranslation } from "react-i18next"

import { useProps } from "contexts/PropsContext"

const getGreetingKey = () => {
  const hour = new Date().getHours()

  if (hour >= 5 && hour < 12) return "greeting.morning"
  if (hour >= 12 && hour < 17) return "greeting.afternoon"
  if (hour >= 17 && hour < 21) return "greeting.evening"
  return "greeting.night"
}

export const WelcomeSection = () => {
  const { user } = useProps()
  const { t } = useTranslation("translation", { useSuspense: false })
  const greetingKey = useMemo(() => getGreetingKey(), [])

  return (
    <div className="flex items-center justify-start sm:justify-center text-xl text-black dark:text-white">
      <p className="text-2xl sm:text-3xl font-medium">
        {t("stats.welcome", { value: "" })}
        <span className="text-[rgba(218,83,255,1)] capitalize">{user?.username || t("common.user")}</span>, {t(greetingKey)}!
      </p>
    </div>
  )
}
